import { z } from 'zod'

const checkInTimeSchema = z.preprocess(
  (value) => (value == null ? null : value),
  z
    .string()
    .regex(/^([0-1][0-9]|2[0-3]):[0-5][0-9]$/)
    .nullable()
)

export const membershipPlanPriceSchema = z.object({
  id: z.string(),
  planId: z.string(),
  durationMonths: z.number(),
  price: z.number(),
  isActive: z.boolean(),
  isDiscountable: z.boolean(),
  createdAt: z.coerce.date(),
  updatedAt: z.coerce.date(),
})

export const membershipPlanCategorySchema = z.enum([
  'standard',
  'semi_personalized',
  'personalized',
])

export const membershipPlanSchema = z.object({
  id: z.string(),
  label: z.string(),
  category: membershipPlanCategorySchema,
  weeklyLimit: z.number().nullable(),
  checkInStart: checkInTimeSchema,
  checkInEnd: checkInTimeSchema,
  isDiscountable: z.boolean(),
  createdAt: z.coerce.date(),
  updatedAt: z.coerce.date(),
  prices: z.array(membershipPlanPriceSchema).optional().default([]),
})

export const membershipPlanListSchema = z.array(membershipPlanSchema)

export const upsertMembershipPlanSchema = z
  .object({
    id: z.string().optional(),
    label: z.string().min(1, 'El nombre es requerido'),
    category: membershipPlanCategorySchema,
    weeklyLimit: z.number().min(1).nullable().optional(),
    checkInStart: z
      .string()
      .regex(/^([0-1][0-9]|2[0-3]):[0-5][0-9]$/, 'Hora inválida')
      .nullable()
      .optional(),
    checkInEnd: z
      .string()
      .regex(/^([0-1][0-9]|2[0-3]):[0-5][0-9]$/, 'Hora inválida')
      .nullable()
      .optional(),
    isDiscountable: z.boolean().optional(),
    prices: z.array(
      z.object({
        id: z.string().optional(),
        planId: z.string().optional(),
        durationMonths: z.number().min(1, 'Duración mínima: 1 mes'),
        price: z.number().min(0, 'Precio debe ser mayor o igual a 0'),
        isActive: z.boolean().optional(),
        isDiscountable: z.boolean().optional(),
      })
    ),
  })
  .superRefine((value, ctx) => {
    if (value.category !== 'personalized' && value.prices.length === 0) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        message: 'Agrega al menos una duración',
        path: ['prices'],
      })
    }
  })

export type MembershipPlan = z.infer<typeof membershipPlanSchema>
export type MembershipPlanPrice = z.infer<typeof membershipPlanPriceSchema>
export type UpsertMembershipPlan = z.infer<typeof upsertMembershipPlanSchema>
